import { useEffect, useState } from "react";
import axios from "axios";
import { Reveal } from "@/components/Reveal";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { ARTICLES } from "@/data/articles";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Journal = () => {
  const [articles, setArticles] = useState(ARTICLES);

  useEffect(() => {
    axios
      .get(`${API}/articles`)
      .then((r) => {
        if (r.data.length > 0) setArticles(r.data);
      })
      .catch(() => {});
  }, []);

  return (
    <section id="journal" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
      <Reveal>
        <p className="mb-4 font-mono text-xs font-medium uppercase tracking-[0.28em] text-pine-700">Resources & Journal</p>
        <h2 className="max-w-xl font-serif text-2xl font-semibold tracking-tight text-pine-950 sm:text-3xl lg:text-4xl">
          Notes from the therapy room.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
        {articles.map((p, i) => (
          <Reveal key={p.slug} delay={i * 0.08}>
            <Link to={`/journal/${p.slug}`} className="block h-full">
              <article
                data-testid={`journal-card-${p.slug}`}
                className="group flex h-full cursor-pointer flex-col justify-between rounded-3xl border border-pine-900/10 bg-white p-8 transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1.5 hover:border-honey hover:shadow-xl"
              >
                <div>
                  <div className="flex items-center justify-between">
                    <span className="rounded-full border border-clay/30 bg-clay/10 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.12em] text-clay">
                      {p.tag}
                    </span>
                    <span className="font-mono text-[11px] text-stone-400">{p.read}</span>
                  </div>
                  <h3 className="mt-6 font-serif text-xl font-semibold leading-snug text-pine-950 transition-colors group-hover:text-pine-700">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-stone-600">{p.excerpt}</p>
                </div>
                <span className="mt-8 flex items-center gap-1.5 text-sm font-semibold text-clay">
                  Read article
                  <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </span>
              </article>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
